import React from "react";

usubscribe.title = "Unsubscribe itmtb";
usubscribe.desc = "Unsubscribe itmtb";
usubscribe.header_img = "https://www.itmtb.com/logo.png";

export default function usubscribe() {
  return (
    <div className="bg-white flex-col h-[100vh] w-[100vw] flex items-center justify-center">
      <h1 className="text-[#363636] text-4xl"> You have unsubscribed successfully. Thank you.</h1>
      <button
        onClick={() => (window.location.href = "/")}
        className="flex items-centers inline-block px-6 py-[12px] my-8 bg-blog-button-bg text-white font-medium text-xs leading-tight shadow-md bg-amber-500 hover:bg-amber-600 hover:shadow-lg focus:bg-amber-600 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-amber-600 active:shadow-lg transition duration-150 ease-in-out"
      >
        Back to itmtb.com
      </button>
    </div>
  );
}
